import "./style.scss";

import React from "react";

import { Text } from '../';

import { TiArrowRepeat } from 'react-icons/ti';


type Props = {
    collection?: any;
    status?: boolean | string;
    css?: object;
    className?: string;
    percentage: string | number | null | undefined;
    myProgressBar?: boolean;
};

function ProgressBar({ collection = null, status = '', percentage, css = {}, className = '', myProgressBar = false }: Props) {
    
    const editableStatus =
        collection !== null &&
        collection?.elementType === 'NODE' &&
        collection?.data?.editable &&
        collection?.data?.nodeType === 'LEARNING' &&
        collection?.data?.status === 'PUBLISHED';

    const editableInactive = editableStatus && collection?.data?.nodeEnrollment?.status === 'NOT_ATTEMPTED';



    const porcValue = percentage !== null && percentage !== undefined ? +percentage : 0;
    const porcString = porcValue.toString() + '%';

    const Style = {
        width: porcString,
        ...css,
    };

    return editableStatus ? (
        <div
            className="pctProgressBarEditableStatus"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className="editableStatusInfo">
                <Text
                    component={'small'}
                    text={`Este treinamento pode receber atualizações ao longo do tempo, por isso não possui porcentagem de conclusão.`}
                />
            </div>
            <div className={'editableStatusTxt'}>
                <TiArrowRepeat />
                <Text component="small" text={`Aprendizado contínuo`} />
            </div>
            <div className={`pctAtom pctProgressBarContainer pctProgressBarContainerEditable`}>
                <div
                    className={`pctProgressBarContainerEditable-bar ${editableInactive ? 'editableInactive' : ''} ${
                        myProgressBar ? 'myProgressBar' : ''
                    }`}
                ></div>
            </div>
        </div>
    ) : percentage !== null && percentage !== undefined ? (
        <div
            className={`pctAtom pctProgressBarContainer ${className} 
          pctProgressModel${status}
          ${porcValue === 100 ? 'pctPBComplete' : ''}`}
        >
            <div className="pctProgressBar" style={Style}></div>
        </div>
    ) : (
        <></>
    );
}

export default ProgressBar